import { jsxs as n, jsx as o } from "react/jsx-runtime";
import i from "react";
import { clsx as a } from "../../utils/clsx.js";
import '../../assets/Indicator.css';const s = "_root_2gp9n_1", e = "_indicator_2gp9n_1", r = {
  root: s,
  indicator: e
}, c = { animationDelay: "0ms" }, m = { animationDelay: "50ms" }, d = { animationDelay: "100ms" }, l = { animationDelay: "150ms" }, v = i.memo(function({
  className: t
}) {
  return /* @__PURE__ */ n("div", { className: a(r.root, t), children: [
    /* @__PURE__ */ o("div", { style: c }),
    /* @__PURE__ */ o("div", { style: m }),
    /* @__PURE__ */ o("div", { style: d }),
    /* @__PURE__ */ o("div", { style: l })
  ] });
});
export {
  v as Indicator
};
